import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { trackMixpanelPageView } from 'helpers/post';
import { connect } from 'react-redux';
import { GET_GO4_WORKED_JOBS } from 'redux/ducks/User';
import { brandsLogo } from 'scenes/V3/CreateEventLandingPage/assets';
import { get } from 'lodash';
import { withQueryParamCapture } from '@helpers/useQueryParamCapture';
import { FAQSection, HiringSection, TestimonialsSection, WelcomeSection, HireATSection } from './Sections';

class CreateEventLandingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      brands: {
        active: false,
      },
    };
    this.brandsCarouselRef = React.createRef();
  }

  componentDidMount() {
    trackMixpanelPageView('/create-account');

    const { go4WorkedJobs } = this.props;
    if (!go4WorkedJobs.init && !go4WorkedJobs.workedJobs) {
      this.props.getGo4WorkedJobs();
    }

    if (this.brandsCarouselRef.current) {
      this.resizeObserver = new ResizeObserver(() => this.checkOverflow(this.brandsCarouselRef));
      this.resizeObserver.observe(this.brandsCarouselRef.current);
    }

    setTimeout(() => {
      this.initScrollAnimations();
    }, 100);
  }

  initScrollAnimations = () => {
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -100px 0px',
      threshold: 0.15,
    };

    this.scrollObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');

          this.scrollObserver.unobserve(entry.target);
        }
      });
    }, observerOptions);

    const animatedElements = document.querySelectorAll('.scroll-animate');
    animatedElements.forEach(el => this.scrollObserver.observe(el));
  };

  componentWillUnmount() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.scrollObserver) this.scrollObserver.disconnect();
  }

  checkOverflow = ref => {
    if (!ref.current) return false;

    const isActive = this.brandsCarouselRef.current.scrollWidth > window.innerWidth;

    this.setState(prevState => ({
      ...prevState,
      brands: {
        ...prevState.brands,
        active: isActive,
      },
    }));

    return isActive;
  };

  onImReady = () => {
    trackMixpanelPageView('LandingPageGetStarted', this.props.user);

    if (!this.props.authenticated) {
      this.props.history.push('/create-account/role');
      return;
    }

    this.props.history.push('/v2/create-event/type');
  };

  institutionsLogoSlides = () => {
    return brandsLogo.map((image, index) => (
      <div className="embla__slide brands" key={`brand-logo-${index}`}>
        <img
          src={image.imageUrl}
          alt={`Institution logo ${index + 1}`}
          className="institution-logo"
          width={image.width}
          height={image.height}
          style={image.objectFit ? { objectFit: image.objectFit } : undefined}
        />
      </div>
    ));
  };

  render() {
    const go4WorkedJobs = get(this.props, 'go4WorkedJobs.workedJobs', 0);

    return (
      <div className="createEventLandingPage">
        <main className="content">
          <WelcomeSection
            go4WorkedJobs={go4WorkedJobs}
            onImReady={this.onImReady}
            institutionsLogoSlides={this.institutionsLogoSlides}
            brandsCarouselRef={this.brandsCarouselRef}
            brands={this.state.brands}
          />
          <HiringSection />
          <TestimonialsSection />
          <FAQSection />
          <HireATSection onImReady={this.onImReady} />
        </main>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.session.currentUser,
  authenticated: state.session.authenticated,
  go4WorkedJobs: state.user.go4WorkedJobs,
});

const mapDispatchToProps = dispatch => ({
  getGo4WorkedJobs: () => dispatch({ type: GET_GO4_WORKED_JOBS }),
});

// Wrap with HOC to automatically capture query parameters
export default withQueryParamCapture(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateEventLandingPage))
);
